const imageStack = {
  displayField: 'title',
  name: 'Blog - Image Stack',
  description: 'Inline component within blog Articles to show a block of images',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'imgs',
      name: 'Images',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 1, max: 3 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'imageWithFocalPoint' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'images',
      name: 'Images',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 1, max: 3 } } ],
      disabled: true,
      omitted: true,
      items: { type: 'Link', validations: [], linkType: 'Asset' }
    }
  ],
  sys: {
    id: 'imageStack',
    version: 13,
    updatedAt: '2023-07-20T17:47:20.677Z'
  }
};
export default imageStack;